import type { FunnelInterrupt } from '../model/interrupts/types';

export const BRANCH_CORRECTION_ACTION = {
  building_credit: 'building_credit',
  continue: 'continue',
} as const;

export const FUNNEL_INTERRUPTS = [
  {
    id: 'branch_correction',
    afterStepId: 'credit_score',
    when: {
      branches: ['travel', 'cash_back', 'balance_transfer', 'saving_interest'],
      answers: ['fair', 'poor', 'no_history'],
    },
    actions: [
      {
        id: BRANCH_CORRECTION_ACTION.building_credit,
        outcome: { kind: 'reset-branch', branchId: 'building_credit' },
      },
      {
        id: BRANCH_CORRECTION_ACTION.continue,
        outcome: { kind: 'continue' },
      },
    ],
  },
] as const satisfies readonly FunnelInterrupt[];
